define('SC.GiftCertificateEnhancement.1.0.0.GiftCertificateVariableAmount', [
    'ProductDetails.Full.View',
    'SC.Configuration',
    'GiftCertificateVariableAmount.View',
    'GiftCertificateVariableAmount.HidePrice.View',
    'jQuery',
    'underscore',
    'GiftCertificateVariableAmount.Site.Configuration',
    'GiftCertificateVariableAmount.ItemsKeyMapping',
    'GiftCertificateVariableAmount.Transaction.Line.Price.View'
], function GiftCertificateVariableAmount(
     ProductDetailsFullView,
     Configuration,
     GiftCertificateVariableAmountView,
     GiftCertificateVariableAmountHidePriceView,
     jQuery,
     _
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var pdp = application.getComponent('PDP');
            var plp = application.getComponent('PLP');
            var cart = application.getComponent('Cart');
            var layout = application.getComponent('Layout');
            var pdpElementsToHide = Configuration.get('giftCertificateEnhancement').fields;

            if (pdp) {
                pdp.on('afterShowContent', function beforeShowContent() {
                    var pdpItemInfo = pdp.getItemInfo();
                    if (pdpItemInfo.item.keyMapping_isWithVariableAmount) {
                        jQuery('[data-view="Product.Price"]').hide();
                    }
                });

                pdp.on('afterShowContent', function afterShowContent() {
                    var pdpItemInfo = pdp.getItemInfo();
                    if (pdpItemInfo.item.keyMapping_isWithVariableAmount || pdpItemInfo.item.itemtype == 'GiftCert' ) {
                        _.each(pdpElementsToHide, function eachPDPElementToHide(elemId) {
                            jQuery('.' + elemId.ifGiftCert + '-controls-group').hide();
                            jQuery('#' + elemId.ifGiftCert + '-controls-group').hide();
                            jQuery('#' + elemId.ifGiftCert + '-container').hide();
                            jQuery('.' + elemId.ifGiftCert + '-container').hide();
                        });
                    } else {
                        _.each(pdpElementsToHide, function eachPDPElementToHide(elemId) {
                            jQuery('.' + elemId.ifNotGiftCert + '-controls-group').hide();
                            jQuery('#' + elemId.ifNotGiftCert + '-controls-group').hide();
                            jQuery('#' + elemId.ifNotGiftCert + '-container').hide();
                            jQuery('.' + elemId.ifNotGiftCert + '-container').hide();
                        });
                    }

                    // Remove Gift Certificate Amount Text Field it no Variable Amount Check
                    if (!pdpItemInfo.item.keyMapping_isGiftCertWithVariableAmount) {
                        _.each(pdpElementsToHide, function eachPDPElementToHide(elemId) {
                            jQuery('.' + elemId.ifNotGiftCert + '-controls-group').hide();
                            jQuery('#' + elemId.ifNotGiftCert + '-controls-group').hide();
                            jQuery('#' + elemId.ifNotGiftCert + '-container').hide();
                            jQuery('.' + elemId.ifNotGiftCert + '-container').hide();
                        });
                    }

                });

                pdp.addChildViews(
                    pdp.PDP_FULL_VIEW, {
                        'Product.Options': {
                            'GiftCertificateVariableAmount.View': {
                                childViewIndex: 10,
                                childViewConstructor: function childViewConstructor() {
                                    return new GiftCertificateVariableAmountView({
                                        pdp: pdp,
                                        application: application,
                                        cart: cart,
                                        layout: layout
                                    });
                                }
                            }
                        }
                    }
                );

                pdp.addChildViews(
                    pdp.PDP_QUICK_VIEW, {
                        'Product.Options': {
                            'GiftCertificateVariableAmount.View': {
                                childViewIndex: 10,
                                childViewConstructor: function childViewConstructor() {
                                    return new GiftCertificateVariableAmountView({
                                        pdp: pdp,
                                        application: application,
                                        cart: cart,
                                        layout: layout
                                    });
                                }
                            }
                        }
                    }
                );
            }

            if (plp) {
                plp.addChildViews(
                    plp.PLP_VIEW,{
                        'ItemDetails.Options': {
                            'GiftCertificateVariableAmount.HidePrice.View': {
                                childViewIndex: 10,
                                childViewConstructor: function childViewConstructor() {
                                    return new GiftCertificateVariableAmountHidePriceView({
                                        plp: plp
                                    })
                                }
                            }
                        }
                    }
                )
            }
        }
    };
});
